import { render } from "./RemoteSearch.vue?vue&type=template&id=2099c5e6"
import script from "./RemoteSearch.vue?vue&type=script&lang=js"
export * from "./RemoteSearch.vue?vue&type=script&lang=js"
script.render = render

export default script